import flagDe from '../assets/flag-de.svg'
import flagEn from '../assets/flag-en.svg'
import { useI18n, type Lang } from '../lib/i18n'

/** Each language by its flag and its own name, in the login page's order (flags copied from its theme). */
const LANGUAGES: readonly (readonly [Lang, string, string])[] = [
  ['de', flagDe, 'Deutsch'],
  ['en', flagEn, 'English'],
]

/** The language choice as two flags, at the navigation's foot and in the reading workspace's top bar. */
export function LanguageToggle() {
  const { t, lang, setLang } = useI18n()
  return (
    <div className="language-toggle" role="group" aria-label={t('language')}>
      {LANGUAGES.map(([code, flag, name]) => (
        <button key={code} type="button" lang={code} aria-label={name} title={name} aria-pressed={lang === code} onClick={() => setLang(code)}>
          <img src={flag} alt="" width="18" height="12" />
        </button>
      ))}
    </div>
  )
}
